export default __webpack_public_path__ + "static/the-power-of-experiments-4a75ea35216d2c91f91432da946ef037.jpg";